import { render, staticRenderFns } from "./approvalList.vue?vue&type=template&id=3814c635&"
import script from "./approvalList.vue?vue&type=script&lang=js&"
export * from "./approvalList.vue?vue&type=script&lang=js&"
import style0 from "./approvalList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports